import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./mui-overrides.css";
import "./react-select-overrides.css";
import "./highcharts.css";
import "./print.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
